import { ConfiguracaoFormasDePagamentoModel } from "../models/configuracaoFormasDePagamentoModel"
import {
    ConfiguracaoFormasDePagamentoActionModel,
    ConfiguracaoFormasDePagamentoActionsTypes,
} from "./configuracaoFormasDePagamentoActions"
import { ConfiguracaoFormasDePagamentoInicial } from "../models/configuracaoFormasDePagamentoModel"

export function configuracaoFormasDePagamentoReducer(
    state: ConfiguracaoFormasDePagamentoModel,
    action: ConfiguracaoFormasDePagamentoActionModel
): ConfiguracaoFormasDePagamentoModel {
    switch (action.type) {
        case ConfiguracaoFormasDePagamentoActionsTypes.CARREGAR:
            return action.payload

        case ConfiguracaoFormasDePagamentoActionsTypes.TOGGLE_ASSOCIADO: {
            const { index } = action.payload
            const formas = [...state.formasPagamento]
            formas[index] = { ...formas[index], associado: !formas[index].associado }
            return { ...state, formasPagamento: formas }
        }

        case ConfiguracaoFormasDePagamentoActionsTypes.ATUALIZAR_CAMPO: {
            const { index, campo, valor } = action.payload
            const formas = [...state.formasPagamento]
            formas[index] = { ...formas[index], [campo]: valor }
            return { ...state, formasPagamento: formas }
        }

        default:
            return state
    }
}
